// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.copy-button-container-z1P31 {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.copy-button-button-K1fXd {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.2s;
  color: rgba(0, 0, 0, 0.75);
}

.copy-button-button-K1fXd:hover {
  background-color: rgba(0, 0, 0, 0.04);
  color: rgba(0, 0, 0, 1);
}

.copy-button-button-K1fXd:active {
  background-color: rgba(0, 0, 0, 0.08);
}

.copy-button-icon-Gx9or {
  --size: 20px;
}

.copy-button-tooltip-AJqZX {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  margin-bottom: 8px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s, transform 0.2s;
  z-index: 10;
}

.copy-button-tooltipShow-GqUbX {
  opacity: 1;
  transform: translateX(-50%) translateY(-4px);
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/copy-button/copy-button.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,UAAU;EACV,4CAA4C;AAC9C","sourcesContent":[".container {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  color: rgba(0, 0, 0, 0.75);\n}\n\n.button:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n  color: rgba(0, 0, 0, 1);\n}\n\n.button:active {\n  background-color: rgba(0, 0, 0, 0.08);\n}\n\n.icon {\n  --size: 20px;\n}\n\n.tooltip {\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  margin-bottom: 8px;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s, transform 0.2s;\n  z-index: 10;\n}\n\n.tooltipShow {\n  opacity: 1;\n  transform: translateX(-50%) translateY(-4px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `copy-button-container-z1P31`,
	"button": `copy-button-button-K1fXd`,
	"icon": `copy-button-icon-Gx9or`,
	"tooltip": `copy-button-tooltip-AJqZX`,
	"tooltipShow": `copy-button-tooltipShow-GqUbX`
};
export default ___CSS_LOADER_EXPORT___;
